import { render, staticRenderFns } from "./UploadFileModal.vue?vue&type=template&id=736897ea&scoped=true&"
import script from "./UploadFileModal.vue?vue&type=script&lang=js&"
export * from "./UploadFileModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileModal.vue?vue&type=style&index=0&id=736897ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736897ea",
  null
  
)

export default component.exports